import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import parse from 'html-react-parser';

const PopupModal = ({ popup, show, onClose, onMarkViewed, totalPopups, currentIndex }) => {
    const handleClose = async () => {
        try {
            await onMarkViewed(popup._id);
            onClose();
        } catch (error) {
            console.error('Error marking popup as viewed:', error);
            onClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {popup?.title}
                    {totalPopups > 1 && (
                        <small className="text-muted ms-2">
                            ({currentIndex} of {totalPopups})
                        </small>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {popup?.image && (
                    <div className="popup-image mb-3">
                        <img 
                            src={process.env.REACT_APP_IMAGE_URL + "/" + popup.image} 
                            alt={popup.title}
                            className="img-fluid"
                        />
                    </div>
                )}
                <div className="popup-content">
                    {popup?.content && parse(popup.content)}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    {currentIndex === totalPopups ? 'Got it!' : 'Next'}
                </Button>
            </Modal.Footer>

            <style jsx>{`
                .popup-image {
                    text-align: center;
                }
                .popup-image img {
                    max-width: 100%;
                    border-radius: 8px;
                }
                .popup-content {
                    font-size: 16px;
                    line-height: 1.5;
                }
            `}</style>
        </Modal>
    );
};

export default PopupModal; 